import { type TableColumnAlignment, type TableHeaderData } from '@components/table/Table';

export type AuthorizedUsersTableVariant = 'current' | 'history';

export type AuthorizedUsersTableConfig = {
  tableId: string;
  defaultSortColumn: string;
  noRecordsText: string;
  headerData: TableHeaderData[][];
  headerWidthsWithStatus?: Record<string, string>;
  statusColumnWidth?: string;
  columnOrder: {
    name: string;
    alignment?: TableColumnAlignment;
  }[];
};

export const authorizedUsersTableConfig: Record<AuthorizedUsersTableVariant, AuthorizedUsersTableConfig> = {
  current: {
    tableId: 'authorized-users-table',
    defaultSortColumn: 'accessGrantedSort',
    noRecordsText: 'No users currently have access to this request.',
    headerData: [
      [
        {
          label: 'User',
          name: 'userSort',
          isSortable: true,
          width: '17%',
        },
        {
          label: 'Role',
          name: 'roleSort',
          isSortable: true,
          width: '15%',
        },
        {
          label: 'Email',
          name: 'emailSort',
          isSortable: true,
          width: '30%',
        },
        {
          label: 'Access Level',
          name: 'accessLevelSort',
          isSortable: true,
          width: '18%',
        },
        {
          label: 'Access Granted',
          name: 'accessGrantedSort',
          isSortable: true,
          defaultSortDirection: 'desc',
          width: '17%',
        },
        {
          label: 'Actions',
          name: 'actions',
          width: '8%',
          isSortable: false,
        },
      ],
    ],
    statusColumnWidth: '30%',
    headerWidthsWithStatus: {
      userSort: '17%',
      roleSort: '15%',
      emailSort: '30%',
      accessLevelSort: '18%',
      accessGrantedSort: '21%',
      actions: '9%',
    },

    columnOrder: [
      { name: 'user' },
      { name: 'role' },
      { name: 'email' },
      { name: 'accessLevel' },
      { name: 'accessGranted' },
      {
        name: 'actions',
        alignment: 'center',
      },
    ],
  },

  history: {
    tableId: 'authorized-users-history-table',
    defaultSortColumn: 'accessEndedSort',
    noRecordsText: 'No users have had their access removed from this request.',
    headerData: [
      [
        {
          label: 'User',
          name: 'userSort',
          isSortable: true,
          width: '14%',
        },
        {
          label: 'Role',
          name: 'roleSort',
          isSortable: true,
          width: '14%',
        },
        {
          label: 'Email',
          name: 'emailSort',
          isSortable: true,
          width: '32%',
        },
        {
          label: 'Access Level',
          name: 'accessLevelSort',
          isSortable: true,
          width: '12%',
        },
        {
          label: 'Access Granted',
          name: 'accessGrantedSort',
          isSortable: true,
          width: '14%',
        },
        {
          label: 'Access Ended',
          name: 'accessEndedSort',
          isSortable: true,
          defaultSortDirection: 'desc',
          width: '14%',
        },
      ],
    ],
    columnOrder: [
      { name: 'user' },
      { name: 'role' },
      { name: 'email' },
      { name: 'accessLevel' },
      { name: 'accessGranted' },
      { name: 'accessEnded' },
    ],
  },
};
